const countryCoordinates = {
  'en-CA': { lat: 56.130366, lng: -106.346771 },
  'en-GB': { lat: 54.7023545, lng: -3.2765753 },
  'en-US': { lat: 40.06317990623726, lng: -98.15307542071716 },
  'fr-FR': { lat: 46.603354, lng: 1.888334 },
  'ja-JP': { lat: 36.204824, lng: 138.252924 },
}

export default countryCoordinates
